class LoggerClass {
    static logLevel = {
        DEBUG: 0,
        INFO: 1,
        WARN: 2,
        ERROR: 3,
    }

    constructor(environment = "development") {
        this.currentLevel =
            environment === "development"
                ? LoggerClass.logLevel.DEBUG
                : LoggerClass.logLevel.WARN
    }

    log(level, context, message, ...data) {
        if (LoggerClass.logLevel[level] >= this.currentLevel) {
            console[level.toLowerCase()](`[${context}] ${message}`, ...data)
        }
    }

    debug(context, message, ...data) {
        this.log("DEBUG", context, message, ...data)
    }

    info(context, message, ...data) {
        this.log("INFO", context, message, ...data)
    }

    warn(context, message, ...data) {
        this.log("WARN", context, message, ...data)
    }

    error(context, message, ...data) {
        this.log("ERROR", context, message, ...data)
    }
}

export const Logger = new LoggerClass(import.meta.env.MODE)
